import { normalizeRole } from '@/auth/permissions';
import { getSession } from './session';

const STORAGE_KEY = 'vendorContextId';

type VendorContextListener = (value: string | null) => void;

const listeners = new Set<VendorContextListener>();

export function getVendorContextId(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  const trimmed = raw.trim();
  return trimmed.length ? trimmed : null;
}

export function setVendorContextId(next: string | null): void {
  if (typeof window === 'undefined') return;
  const normalized = typeof next === 'string' ? next.trim() : '';
  try {
    if (!normalized) {
      window.localStorage.removeItem(STORAGE_KEY);
      listeners.forEach(listener => listener(null));
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, normalized);
    listeners.forEach(listener => listener(normalized));
  } catch {
    // ignore storage errors
  }
}

export function subscribeVendorContext(listener: VendorContextListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getVendorContextHeaderValue(): string | null {
  const vendorId = getVendorContextId();
  if (!vendorId) return null;
  const role = normalizeRole(getSession()?.user?.role);
  return role === 'ADMIN' ? vendorId : null;
}

export const VENDOR_CONTEXT_STORAGE_KEY = STORAGE_KEY;
